import React from 'react';
import { Code, Upload } from 'lucide-react';
import { QUESTION_TYPES } from '../../constants';
import { Badge } from '../ui/badge';

const TYPE_CONFIG = {
  [QUESTION_TYPES.MCQ]: { label: 'Multiple Choice', color: 'bg-blue-100 text-blue-800' },
  [QUESTION_TYPES.FIB]: { label: 'Fill in the Blanks', color: 'bg-green-100 text-green-800' },
  [QUESTION_TYPES.SUBJECTIVE]: { label: 'Subjective Answer', color: 'bg-purple-100 text-purple-800' },
  [QUESTION_TYPES.CODE]: { label: 'Coding Problem', color: 'bg-orange-100 text-orange-800', icon: Code },
  [QUESTION_TYPES.FILE_UPLOAD]: {
    label: 'Document Upload',
    color: 'bg-pink-100 text-pink-800',
    icon: Upload
  },
  [QUESTION_TYPES.AUDIO]: { label: 'Audio Recording', color: 'bg-cyan-100 text-cyan-800' },
  [QUESTION_TYPES.VIDEO]: { label: 'Video Recording', color: 'bg-indigo-100 text-indigo-800' },
  [QUESTION_TYPES.READING_COMPREHENSION]: {
    label: 'Reading Comprehension',
    color: 'bg-indigo-100 text-indigo-800'
  }
};

const QuestionTypeBadge = ({ type, className }) => {
  const config = TYPE_CONFIG[type] || { label: 'Question', color: 'bg-gray-100 text-gray-800' };
  const Icon = config.icon;

  return (
    <Badge className={`${config.color} px-3 py-1 text-xs font-medium ${className || ''}`}>
      {Icon && <Icon className="mr-1 h-3 w-3" />}
      {config.label}
    </Badge>
  );
};

export { QuestionTypeBadge, TYPE_CONFIG };
